import { FieldSchema } from '../_generated/client/model/fieldSchema';

export const fakeDataRequired = [
    {
        buttonText: 'Create Account',
        category: 'Application',
        description: 'Factory stage schema for creating prospect',
        fieldSchemas: [
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-title',
                isReadOnly: true,
                label: "Let's get started",
                name: 'PageTitle',
                textStyle: FieldSchema.TextStyleEnum.Head1,
                tooltip: ''
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-description',
                isReadOnly: true,
                label:
                    'Before you begin, please ensure you can accept legal agreements on behalf of your organization. Additional information may be requested as part of the application review process.',
                name: 'PageDescription',
                tooltip: ''
            },
            {
                fieldOption: {
                    maxLength: 50
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-first-name',
                isRequired: true,
                label: 'First Name',
                name: 'FirstName',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    maxLength: 50
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-last-name',
                isRequired: true,
                label: 'Last Name',
                name: 'LastName',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    inputType: 'Email'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-email',
                isReadOnly: true,
                isRequired: true,
                label: 'Email Address',
                name: 'Email',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    inputType: 'Tel',
                    mask: '(000) 000-0000'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-mobile',
                isRequired: true,
                label: 'Mobile Number',
                name: 'MobileNumber',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    inputType: 'Password'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-password1',
                isRequired: true,
                label: 'Create Password',
                name: 'Password1',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    inputType: 'Password'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-password2',
                isRequired: true,
                label: 'Confirm Password',
                name: 'Password2',
                tooltip: '',
                width: '50%'
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-text',
                isReadOnly: true,
                label:
                    'Passwords must be at least 8 characters, contain one number, one capital letter, one lowercase letter, and one special character.',
                name: 'PageText1',
                textStyle: FieldSchema.TextStyleEnum.Head5,
                tooltip: ''
            },
            {
                fieldOption: {
                    links: [
                        {
                            action: 'Redirect',
                            endIndex: 63,
                            link: 'https://lsq.com/terms/',
                            startIndex: 47
                        },
                        {
                            action: 'Redirect',
                            endIndex: 82,
                            link: 'https://lsq.com/privacy/',
                            startIndex: 68
                        }
                    ]
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-text',
                isReadOnly: true,
                label:
                    'By clicking “Create Account”, you agree to the Terms of Service and Privacy Policy. You confirm that you’re the owner or primary user of this phone number and you agree to receive automated texts to confirm your number. Message and data rates may apply.',
                name: 'PageText2',
                tooltip: ''
            }
        ],
        id: 'stage-schema-create-account',
        isAdminReviewable: true,
        label: 'Create account',
        name: 'CreateAccount',
        reviewTitle: 'Application User'
    },
    {
        buttonText: 'Confirm Email',
        category: 'Application',
        description: 'Factory stage schema for creating prospect.',
        fieldSchemas: [
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-title',
                isReadOnly: true,
                label: 'Please confirm your email',
                name: 'PageTitle',
                textStyle: FieldSchema.TextStyleEnum.Head2,
                tooltip: ''
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-description',
                isReadOnly: true,
                label:
                    'We require email verification for an additional layer of security. Please enter the security code that was just emailed to you. If the email is missing, be sure to check your spam folder.',
                name: 'PageDescription',
                tooltip: ''
            },
            {
                fieldOption: {
                    inputType: 'VerificationCode',
                    mask: '000000',
                    maxLength: 6,
                    pattern: '^[0-9]{6}$'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-email-code',
                isRequired: true,
                label: 'Enter Email code',
                name: 'EmailCode',
                tooltip: '',
                width: '55%'
            },
            {
                fieldOption: {
                    links: [
                        {
                            action: 'Api',
                            endIndex: 28,
                            link: 'resendEmail',
                            startIndex: 22
                        }
                    ]
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-text',
                isReadOnly: true,
                label: 'Not seeing our email? RESEND',
                name: 'PageText1',
                textStyle: FieldSchema.TextStyleEnum.Head5,
                tooltip: ''
            }
        ],
        id: 'stage-schema-create-account-email-confirmation',
        label: 'Confirm email',
        name: 'CreateAccountEmailConfirmation'
    },
    {
        buttonText: 'Complete MFA Setup',
        category: 'Application',
        description: 'Factory stage schema for creating prospect.',
        fieldSchemas: [
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-title',
                isReadOnly: true,
                label: 'Secure your account',
                name: 'PageTitle',
                textStyle: FieldSchema.TextStyleEnum.Head2,
                tooltip: ''
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-description',
                isReadOnly: true,
                label:
                    'We require that all accounts use multi-factor authentication (commonly known as MFA) for the extra layer of protection it provides. Logging into FastTrack with MFA will require:',
                name: 'PageDescription',
                tooltip: ''
            },
            {
                fieldOption: {
                    backgroundColor: '#F7F8FB',
                    startIcon: 'Account'
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-label-account',
                isReadOnly: true,
                label: 'Username / Email Address',
                name: 'PageLabelAccount',
                tooltip: '',
                width: '55%'
            },
            {
                fieldOption: {
                    backgroundColor: '#F7F8FB',
                    startIcon: 'Password'
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-label-password',
                isReadOnly: true,
                label: 'Password',
                name: 'PageLabelPassword',
                tooltip: '',
                width: '55%'
            },
            {
                fieldOption: {
                    backgroundColor: '#F7F8FB',
                    startIcon: 'SMS'
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-label-sms',
                isReadOnly: true,
                label: 'Verification Code sent via SMS',
                name: 'PageLabelSMS',
                tooltip: '',
                width: '55%'
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-text',
                isReadOnly: true,
                label:
                    'Even if your password is acquired, your account will still be protected by your mobile phone. To complete MFA setup, please enter the code sent via SMS to the mobile number provided:',
                name: 'PageText4',
                tooltip: ''
            },
            {
                fieldOption: {
                    referenceValue: 'stage-schema-create-account.field-schema-mobile'
                },
                fieldType: FieldSchema.FieldTypeEnum.EditPhoneField,
                id: 'field-schema-edit-phone',
                isReadOnly: true,
                label: '',
                name: 'EditPhone',
                tooltip: ''
            },
            {
                fieldOption: {
                    inputType: 'VerificationCode',
                    mask: '000000',
                    maxLength: 6,
                    pattern: '^[0-9]{6}$'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-sms-code',
                isRequired: true,
                label: 'Enter SMS code',
                name: 'SMSCode',
                tooltip: '',
                width: '55%'
            },
            {
                fieldOption: {
                    links: [
                        {
                            action: 'Api',
                            endIndex: 35,
                            link: 'resendMFA',
                            startIndex: 29
                        }
                    ]
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-text',
                isReadOnly: true,
                label: "Didn't receive the SMS code? RESEND",
                name: 'PageText6',
                textStyle: FieldSchema.TextStyleEnum.Head5,
                tooltip: ''
            }
        ],
        id: 'stage-schema-create-account-two-factor',
        label: 'Enable multi-factor authentication',
        name: 'CreateAccountTwoFactor'
    },
    {
        category: 'Application',
        description: 'Stage for collecting business information',
        fieldSchemas: [
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-title',
                isReadOnly: true,
                label: 'Tell us about your business',
                name: 'PageTitle',
                textStyle: FieldSchema.TextStyleEnum.Head2,
                tooltip: ''
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-description',
                isReadOnly: true,
                label:
                    'Please provide important information about your business. Additional information may be requested as part of the application review process.',
                name: 'PageDescription',
                tooltip: ''
            },
            {
                fieldOption: {
                    hasUnderline: true
                },
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-section',
                isReadOnly: true,
                label: 'Business Information',
                name: 'PageSection',
                textStyle: FieldSchema.TextStyleEnum.Head3,
                tooltip: ''
            },
            {
                fieldOption: {
                    maxLength: 250
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-name',
                isReadOnly: true,
                isRequired: true,
                label: 'Business Name',
                name: 'BusinessName',
                tooltip: 'The business name of your company. max of 250 characters',
                width: '50%'
            },
            {
                fieldOption: {
                    members: [
                        'Agency Services (Consulting, Creative, Marketing, Advertising)',
                        'Agriculture (Non-PACA)',
                        'Agriculture (PACA)',
                        'Apparel & Textiles',
                        'Architecture',
                        'Bank',
                        'Business & Industrial Services',
                        'Commodities',
                        'Construction',
                        'Consumer G&S',
                        'Education',
                        'Energy, Oil, Gas',
                        'Factor',
                        'Financial Services',
                        'Fish & Food',
                        'Government',
                        'Healthcare Equipment',
                        'Healthcare Services',
                        'Manufacturing',
                        'Real Estate',
                        'Restaurant',
                        'Retail',
                        'Software & Technology',
                        'Staffing & Recruiting',
                        'Telecommunications',
                        'Transportation (Non-trucking)',
                        'Trucking',
                        'Wholesale Distribution',
                        'Other'
                    ]
                },
                fieldType: FieldSchema.FieldTypeEnum.DropdownField,
                id: 'field-schema-business-industry',
                isRequired: true,
                label: 'Business Industry',
                name: 'BusinessIndustry',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    maxLength: 250
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-tax-id',
                label: 'Business Tax ID Number',
                name: 'BusinessTaxId',
                tooltip: 'The business tax ID of your company. max of 250 characters',
                width: '50%'
            },
            {
                fieldOption: {
                    maxLength: 250
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-website',
                label: 'Website',
                name: 'BusinessWebsite',
                tooltip: 'Website of your business',
                width: '50%'
            },
            {
                fieldOption: {
                    maxLength: 250
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-address-main',
                isRequired: true,
                label: 'Business Address',
                name: 'BusinessAddressMain',
                tooltip: 'The business main address of your company. max of 250 characters'
            },
            {
                fieldOption: {
                    maxLength: 250
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-address-secondary',
                label: 'Address Line 2',
                name: 'BusinessAddressSecondary',
                tooltip: 'The business secondary address of your company. max of 250 characters'
            },
            {
                fieldOption: {
                    maxLength: 250
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-city',
                isRequired: true,
                label: 'Business City',
                name: 'BusinessCity',
                tooltip: 'The business city of your company. max of 250 characters'
            },
            {
                fieldOption: {
                    members: [
                        'Alabama',
                        'Alaska',
                        'American Samoa',
                        'Arizona',
                        'Arkansas',
                        'California',
                        'Colorado',
                        'Connecticut',
                        'Delaware',
                        'District Of Columbia',
                        'Federated States Of Micronesia',
                        'Florida',
                        'Georgia',
                        'Guam',
                        'Hawaii',
                        'Idaho',
                        'Illinois',
                        'Indiana',
                        'Iowa',
                        'Kansas',
                        'Kentucky',
                        'Louisiana',
                        'Maine',
                        'Marshall Islands',
                        'Maryland',
                        'Massachusetts',
                        'Michigan',
                        'Minnesota',
                        'Mississippi',
                        'Missouri',
                        'Montana',
                        'Nebraska',
                        'Nevada',
                        'New Hampshire',
                        'New Jersey',
                        'New Mexico',
                        'New York',
                        'North Carolina',
                        'North Dakota',
                        'Northern Mariana Islands',
                        'Ohio',
                        'Oklahoma',
                        'Oregon',
                        'Palau',
                        'Pennsylvania',
                        'Puerto Rico',
                        'Rhode Island',
                        'South Carolina',
                        'South Dakota',
                        'Tennessee',
                        'Texas',
                        'Utah',
                        'Vermont',
                        'Virginia',
                        'Virgin Islands',
                        'Washington',
                        'West Virginia',
                        'Wisconsin',
                        'Wyoming'
                    ]
                },
                fieldType: FieldSchema.FieldTypeEnum.DropdownField,
                id: 'field-schema-business-state',
                isRequired: true,
                label: 'Business State',
                name: 'BusinessState',
                tooltip: '',
                width: '50%'
            },
            {
                fieldOption: {
                    pattern: '(^\\d{5}$)|(^\\d{9}$)|(^\\d{5}-\\d{4}$)'
                },
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                id: 'field-schema-business-zip',
                isRequired: true,
                label: 'Postal Code',
                name: 'BusinessZip',
                tooltip: 'The business postal code of your company.',
                width: '50%'
            }
        ],
        id: 'stage-schema-business-information',
        isAdminReviewable: true,
        isReviewable: true,
        label: 'Tell us about your business',
        name: 'BusinessInformation',
        reviewTitle: 'Business Information'
    },
    {
        category: 'Application',
        description: 'Stage for uploading documents',
        fieldSchemas: [
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-title',
                isReadOnly: true,
                label: 'Please provide some documentation',
                name: 'PageTitle',
                textStyle: FieldSchema.TextStyleEnum.Head1,
                tooltip: ''
            },
            {
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                id: 'field-schema-page-description',
                isReadOnly: true,
                label:
                    'In order to expedite your application, please provide the documents requested below. You may submit multiples of each document type if applicable. Additional documentation may be requested as part of the application review process.',
                name: 'PageDescription',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Current receivables aging statement.',
                    documentType: '?',
                    fileExtensions: '*'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-1',
                isRequired: true,
                label: 'A/R Aging',
                name: 'document-1',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Previous annual up to most recent quarter.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-2',
                isRequired: true,
                label: 'Income Statement',
                name: 'document-2',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Previous annual up to most recent quarter.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-3',
                isRequired: true,
                label: 'Balance Sheet',
                name: 'document-3',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'List of customers with associated credit amounts.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-4',
                label: 'Customer List',
                name: 'document-4',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Official documents on the formation of your business.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-5',
                label: 'Articles of Incorporation or Organization',
                name: 'document-5',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Current payables aging statement.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-6',
                label: 'A/P Aging',
                name: 'document-6',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Most recent invoice for top 5 customers.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-7',
                label: 'Recent Invoices',
                name: 'document-7',
                tooltip: ''
            },
            {
                fieldOption: {
                    copy: 'Most recent formal agreements.',
                    documentType: '?',
                    fileExtensions: '.pdf'
                },
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                id: 'field-schema-document-field-8',
                label: 'Contracts or Vendor Agreements',
                name: 'document-8',
                tooltip: ''
            }
        ],
        id: 'stage-schema-documents',
        isAdminReviewable: true,
        isBackward: true,
        isReviewable: true,
        label: 'Provide documentation',
        name: 'Documents',
        reviewTitle: 'Documents'
    },
    {
        buttonText: 'Submit Application',
        category: 'Application',
        description:
            'Please review your application details and submit below when ready. If you need to change anything after submission our Sales team will be able to assist you.',
        fieldSchemas: null,
        id: 'stage-schema-review-submit',
        isBackward: true,
        label: 'Review and submit application',
        name: 'ReviewSubmit'
    }
];

export const fakeDataLessRequired = [
    {
        id: 'stage-schema-create-account',
        name: 'CreateAccount',
        category: 'Application',
        label: 'Create account',
        description: 'Factory stage schema for creating prospect',
        buttonText: 'Create Account',
        isReviewable: false,
        isAdminReviewable: true,
        reviewTitle: 'Application User',
        fieldSchemas: [
            {
                id: 'field-schema-page-title',
                name: 'PageTitle',
                label: "Let's get started",
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                textStyle: FieldSchema.TextStyleEnum.Head1,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-page-description',
                name: 'PageDescription',
                label:
                    'Before you begin, please ensure you can accept legal agreements on behalf of your organization. Additional information may be requested as part of the application review process.',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-first-name',
                name: 'FirstName',
                label: 'First Name',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 50
                },
                width: '50%'
            },
            {
                id: 'field-schema-last-name',
                name: 'LastName',
                label: 'Last Name',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 50
                },
                width: '50%'
            },
            {
                id: 'field-schema-email',
                name: 'Email',
                label: 'Email Address',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    inputType: 'Email'
                },
                width: '50%'
            },
            {
                id: 'field-schema-mobile',
                name: 'MobileNumber',
                label: 'Mobile Number',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    inputType: 'Tel'
                },
                width: '50%'
            },
            {
                id: 'field-schema-password1',
                name: 'Password1',
                label: 'Create Password',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    inputType: 'Password'
                },
                width: '50%'
            },
            {
                id: 'field-schema-password2',
                name: 'Password2',
                label: 'Confirm Password',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    inputType: 'Password'
                },
                width: '50%'
            },
            {
                id: 'field-schema-page-text',
                name: 'PageText1',
                label:
                    'Passwords must be at least 8 characters, contain one number, one capital letter, one lowercase letter, and one special character.',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head5
            },
            {
                id: 'field-schema-page-text',
                name: 'PageText2',
                label:
                    'By clicking “Create Account”, you agree to the Terms of Service and Privacy Policy. You confirm that you’re the owner or primary user of this phone number and you agree to receive automated texts to confirm your number. Message and data rates may apply.',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                fieldOption: {
                    links: [
                        {
                            startIndex: 47,
                            endIndex: 63,
                            link: 'https://lsq.com/terms/',
                            action: 'Redirect'
                        },
                        {
                            startIndex: 68,
                            endIndex: 82,
                            link: 'https://lsq.com/privacy/',
                            action: 'Redirect'
                        }
                    ]
                }
            }
        ]
    },
    {
        id: 'stage-schema-create-account-email-confirmation',
        name: 'CreateAccountEmailConfirmation',
        category: 'Application',
        label: 'Confirm email',
        description: 'Factory stage schema for creating prospect.',
        buttonText: 'Confirm Email',
        isBackward: false,
        isReviewable: false,
        fieldSchemas: [
            {
                id: 'field-schema-page-title',
                name: 'PageTitle',
                label: 'Please confirm your email',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head2
            },
            {
                id: 'field-schema-page-description',
                name: 'PageDescription',
                label:
                    'We require email verification for an additional layer of security. Please enter the security code that was just emailed to you. If the email is missing, be sure to check your spam folder.',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-email-code',
                name: 'EmailCode',
                label: 'Enter Email code',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    pattern: '^[0-9]{6}$'
                },
                width: '55%'
            },
            {
                id: 'field-schema-page-text',
                name: 'PageText1',
                label: 'Not seeing our email? RESEND',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head5,
                fieldOption: {
                    links: [
                        {
                            startIndex: 22,
                            endIndex: 28,
                            link: 'resendEmail',
                            action: 'Api'
                        }
                    ]
                }
            }
        ]
    },
    {
        id: 'stage-schema-create-account-two-factor',
        name: 'CreateAccountTwoFactor',
        category: 'Application',
        label: 'Enable multi-factor authentication',
        description: 'Factory stage schema for creating prospect.',
        buttonText: 'Complete MFA Setup',
        isBackward: false,
        isReviewable: false,
        fieldSchemas: [
            {
                id: 'field-schema-page-title',
                name: 'PageTitle',
                label: 'Secure your account',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head2
            },
            {
                id: 'field-schema-page-description',
                name: 'PageDescription',
                label:
                    'We require that all accounts use multi-factor authentication (commonly known as MFA) for the extra layer of protection it provides. Logging into FastTrack with MFA will require:',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-label-account',
                name: 'PageLabelAccount',
                label: 'Username / Email Address',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                fieldOption: {
                    backgroundColor: '#F7F8FB',
                    startIcon: 'Account'
                },
                width: '55%'
            },
            {
                id: 'field-schema-label-password',
                name: 'PageLabelPassword',
                label: 'Password',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                fieldOption: {
                    backgroundColor: '#F7F8FB',
                    startIcon: 'Password'
                },
                width: '55%'
            },
            {
                id: 'field-schema-label-sms',
                name: 'PageLabelSMS',
                label: 'Verification Code sent via SMS',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                fieldOption: {
                    backgroundColor: '#F7F8FB',
                    startIcon: 'SMS'
                },
                width: '55%'
            },
            {
                id: 'field-schema-text1',
                name: 'PageLabelText1',
                label:
                    'Even if your password is acquired, your account will still be protected by your mobile phone. To complete MFA setup, please enter the code sent via SMS to the mobile number provided:',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-mobile',
                name: 'EditPhone',
                label: '',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.EditPhoneField,
                fieldOption: {
                    referenceValue: 'stage-schema-create-account.field-schema-mobile'
                }
            },
            {
                id: 'field-schema-sms-code',
                name: 'MFACode',
                label: 'Enter SMS code',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    pattern: '^[0-9]{6}$'
                },
                width: '55%'
            },
            {
                id: 'field-schema-resend-mfa',
                name: 'PageResendMFA',
                label: "Didn't receive the SMS code? RESEND",
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head5,
                fieldOption: {
                    links: [
                        {
                            startIndex: 29,
                            endIndex: 35,
                            link: 'resendMFA',
                            action: 'Api'
                        }
                    ]
                }
            }
        ]
    },
    {
        id: 'stage-schema-business-information',
        name: 'BusinessInformation',
        category: 'Application',
        label: 'Tell us about your business',
        description: 'Stage for collecting business information',
        isBackward: false,
        isReviewable: true,
        isAdminReviewable: true,
        reviewTitle: 'Business Information',
        fieldSchemas: [
            {
                id: 'field-schema-page-title',
                name: 'PageTitle',
                label: 'Tell us about your business',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head2
            },
            {
                id: 'field-schema-page-description',
                name: 'PageDescription',
                label:
                    'Please provide important information about your business. Additional information may be requested as part of the application review process.',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-page-section',
                name: 'PageSection',
                label: 'Business Information',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField,
                textStyle: FieldSchema.TextStyleEnum.Head3,
                fieldOption: {
                    hasUnderline: true
                }
            },
            {
                id: 'field-schema-business-name',
                name: 'BusinessName',
                label: 'Business Name',
                tooltip: 'The business name of your company. max of 250 characters',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 250
                },
                width: '50%'
            },
            {
                id: 'field-schema-business-industry',
                name: 'BusinessIndustry',
                label: 'Business Industry',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.DropdownField,
                fieldOption: {
                    members: [
                        'Agency Services (Consulting, Creative, Marketing, Advertising)',
                        'Agriculture (Non-PACA)',
                        'Agriculture (PACA)',
                        'Apparel & Textiles',
                        'Architecture',
                        'Bank',
                        'Business & Industrial Services',
                        'Commodities',
                        'Construction',
                        'Consumer G&S',
                        'Education',
                        'Energy, Oil, Gas',
                        'Factor',
                        'Financial Services',
                        'Fish & Food',
                        'Government',
                        'Healthcare Equipment',
                        'Healthcare Services',
                        'Manufacturing',
                        'Real Estate',
                        'Restaurant',
                        'Retail',
                        'Software & Technology',
                        'Staffing & Recruiting',
                        'Telecommunications',
                        'Transportation (Non-trucking)',
                        'Trucking',
                        'Wholesale Distribution'
                    ]
                },
                width: '50%'
            },
            {
                id: 'field-schema-business-tax-id',
                name: 'BusinessTaxId',
                label: 'Business Tax ID Number',
                tooltip: 'The business tax ID of your company. max of 250 characters',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 250
                },
                width: '50%'
            },
            {
                id: 'field-schema-business-website',
                name: 'BusinessWebsite',
                label: 'Website',
                tooltip: 'Website of your business',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 250
                },
                width: '50%'
            },
            {
                id: 'field-schema-business-address-main',
                name: 'BusinessAddressMain',
                label: 'Business Address',
                tooltip: 'The business main address of your company. max of 250 characters',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 250
                }
            },
            {
                id: 'field-schema-business-address-secondary',
                name: 'BusinessAddressSecondary',
                label: 'Address Line 2',
                tooltip: 'The business secondary address of your company. max of 250 characters',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 250
                }
            },
            {
                id: 'field-schema-business-city',
                name: 'BusinessCity',
                label: 'Business City',
                tooltip: 'The business city of your company. max of 250 characters',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    maxLength: 250
                }
            },
            {
                id: 'field-schema-business-state',
                name: 'BusinessState',
                label: 'Business State',
                tooltip: '',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.DropdownField,
                fieldOption: {
                    members: [
                        'Alabama',
                        'Alaska',
                        'American Samoa',
                        'Arizona',
                        'Arkansas',
                        'California',
                        'Colorado',
                        'Connecticut',
                        'Delaware',
                        'District Of Columbia',
                        'Federated States Of Micronesia',
                        'Florida',
                        'Georgia',
                        'Guam',
                        'Hawaii',
                        'Idaho',
                        'Illinois',
                        'Indiana',
                        'Iowa',
                        'Kansas',
                        'Kentucky',
                        'Louisiana',
                        'Maine',
                        'Marshall Islands',
                        'Maryland',
                        'Massachusetts',
                        'Michigan',
                        'Minnesota',
                        'Mississippi',
                        'Missouri',
                        'Montana',
                        'Nebraska',
                        'Nevada',
                        'New Hampshire',
                        'New Jersey',
                        'New Mexico',
                        'New York',
                        'North Carolina',
                        'North Dakota',
                        'Northern Mariana Islands',
                        'Ohio',
                        'Oklahoma',
                        'Oregon',
                        'Palau',
                        'Pennsylvania',
                        'Puerto Rico',
                        'Rhode Island',
                        'South Carolina',
                        'South Dakota',
                        'Tennessee',
                        'Texas',
                        'Utah',
                        'Vermont',
                        'Virgin Islands',
                        'Virginia',
                        'Washington',
                        'West Virginia',
                        'Wisconsin',
                        'Wyoming'
                    ]
                },
                width: '50%'
            },
            {
                id: 'field-schema-business-zip',
                name: 'BusinessZip',
                label: 'Postal Code',
                tooltip: 'The business postal code of your company.',
                isRequired: false,
                fieldType: FieldSchema.FieldTypeEnum.StringField,
                fieldOption: {
                    pattern: '(^\\d{5}$)|(^\\d{9}$)|(^\\d{5}-\\d{4}$)'
                },
                width: '50%'
            }
        ]
    },
    {
        id: 'stage-schema-documents',
        name: 'Documents',
        category: 'Application',
        label: 'Provide documentation',
        description: 'Stage for uploading documents',
        isBackward: true,
        isReviewable: true,
        isAdminReviewable: true,
        reviewTitle: 'Documents',
        fieldSchemas: [
            {
                id: 'field-schema-page-title',
                name: 'PageTitle',
                label: 'Please provide some documentation',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                textStyle: FieldSchema.TextStyleEnum.Head1,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-page-description',
                name: 'PageDescription',
                label:
                    'In order to expedite your application, please provide the documents requested below. You may submit multiples of each document type if applicable. Additional documentation may be requested as part of the application review process.',
                tooltip: '',
                isRequired: false,
                isReadOnly: true,
                fieldType: FieldSchema.FieldTypeEnum.LabelField
            },
            {
                id: 'field-schema-document-field-1',
                name: 'document-1',
                label: 'A/R Aging',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '*',
                    copy: 'Current receivables aging statement.'
                }
            },
            {
                id: 'field-schema-document-field-2',
                name: 'document-2',
                label: 'Income Statement',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'Previous annual up to most recent quarter.'
                }
            },
            {
                id: 'field-schema-document-field-3',
                name: 'document-3',
                label: 'Balance Sheet',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'Previous annual up to most recent quarter.'
                }
            },
            {
                id: 'field-schema-document-field-4',
                name: 'document-4',
                label: 'Customer List',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'List of customers with associated credit amounts.'
                }
            },
            {
                id: 'field-schema-document-field-5',
                name: 'document-5',
                label: 'Articles of Incorporation or Organization',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'Official documents on the formation of your business.'
                }
            },
            {
                id: 'field-schema-document-field-6',
                name: 'document-6',
                label: 'A/P Aging',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'Current payables aging statement.'
                }
            },
            {
                id: 'field-schema-document-field-7',
                name: 'document-7',
                label: 'Recent Invoices',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'Most recent invoice for top 5 customers.'
                }
            },
            {
                id: 'field-schema-document-field-8',
                name: 'document-8',
                label: 'Contracts or Vendor Agreements',
                tooltip: '',
                isRequired: false,
                isReadOnly: false,
                fieldType: FieldSchema.FieldTypeEnum.DocumentField,
                fieldOption: {
                    documentType: '?',
                    fileExtensions: '.pdf',
                    copy: 'Most recent formal agreements.'
                }
            }
        ]
    },
    {
        id: 'stage-schema-review-submit',
        name: 'ReviewSubmit',
        category: 'Application',
        label: 'Review and submit application',
        description:
            'Please review your application details and submit below when ready. If you need to change anything after submission our Sales team will be able to assist you.',
        isBackward: true,
        isReviewable: false,
        buttonText: 'Submit Application'
    }
];

export const mockARApplication = [
    {
        id: 'default-schema',
        name: 'Default Schema',
        fileSizeLimitMB: 10,
        schemaType: 'ArProspect',
        stageSchemas: fakeDataRequired
    }
];
